module.exports = __webpack_public_path__ + "aa3096403e744b8040ea4c6f08885fff.svg";